import {IPinData} from "../services/PinApi";
import {L} from "../lt-ng/landcare-toolkit";
import Item = L.tree.Item;
import {_F} from "../utility/func";
import friendlyNZTMCoords = _F.friendlyNZTMCoords;
import {LTServices} from "../lt-ng/lt-services";
import IMapService = LTServices.IMapService;
import {IPinExtraDataService} from "../services/pin-extra-data-service";
import getLayersForPointQuery = L.tree.getLayersForPointQuery;
import WFSLayer = L.util.WFSLayer;
import KoordinatesLayer = L.util.KoordinatesLayer;
import {transform} from "ol/proj";
import getScienceLayers = L.tree.getScienceLayers;
import {Feature} from "ol";
import {Point} from "ol/geom";

interface PointAttributesBindings {
    pinData: Feature<Point>;
    height: number;
    expandAlways: boolean;
}

let getApi : (item : Item) => KoordinatesLayer|WFSLayer = (i) => {
    let ls = i.layerService;
    if (!ls) return null;
    return ls.koordinatesLayer || (ls.WFSLayers && ls.WFSLayers.length && ls.WFSLayers[0]);
};

let getLayersWithPointQueryAttributes = (mapService: IMapService, aboveOrBelowFold: boolean) => {
    return getLayersForPointQuery(mapService.treeData, (api) => {
            return api.aboveFold == aboveOrBelowFold
        })
        .filter(n => !!n)
        .sort((a, b) => {
            let apiA = getApi(a);
            let apiB = getApi(b);
            if (apiA && apiB && apiA.order - apiB.order) {
                return apiA.order - apiB.order;
            }
            return a.name.localeCompare(b.name);
        });
};

class PointAttributesController implements PointAttributesBindings, ng.IComponentController {
    height: number;
    pinData: Feature<Point>;
    expandAlways: boolean;

    constructor(protected mapService: IMapService,
                protected pinExtraDataService: IPinExtraDataService) {
    }

    get aboveFoldLayers(): Item[] {
        return getLayersWithPointQueryAttributes(this.mapService, true);
    }

    get belowFoldLayers(): Item[] {
        const aboveFold = this.aboveFoldLayers;

        return getLayersWithPointQueryAttributes(this.mapService, false)
            .filter(item => aboveFold.indexOf(item) === -1);
    }

    _mainAttributes: any[];
    mainAttributes() {
        if (!this._mainAttributes && this.pinData) {
            this._mainAttributes= this.pinExtraDataService.getAttributes(this.pinData, this.aboveFoldLayers);
        }

        return this._mainAttributes;
    }

    _extraAttributes;
    extraAttributes() {
        if (!this._extraAttributes && this.pinData) {
            this._extraAttributes= this.pinExtraDataService.getAttributes(this.pinData, this.belowFoldLayers);
        }

        return this._extraAttributes;
    }

    toggleAttributes(event: Event) {
        this.showExtraAttributes = !this.showExtraAttributes;
        event.preventDefault();
        return false;
    }

    showExtraAttributes: boolean = false;

    friendlyCoords() {
        try{
            return friendlyNZTMCoords(this.pinData.getGeometry().getCoordinates());
        } catch (e) {
            return '';
        }
    };

    lonLat() {
        return  this.pinData ? transform(
            this.pinData.getGeometry().getCoordinates(),
                this.mapService.map.getView().getProjection(),
            'EPSG:4326') : null;
    };
}

export class PointAttributes implements ng.IComponentOptions {
    controller = ['landcareMapService', 'pinExtraDataService', PointAttributesController];

    bindings = {
        height: '<',
        pinData: '<',
        expandAlways: '<'
    };

    templateUrl = '/Partial/component/PointAttributes'
}